import React, { useState } from 'react'
import SnackBarUtils from '../../../utils/SnackBarUtils'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { ITenant } from '../../../pages/AbmLocalPage/types'

export interface ResData {
  idLocal: number
  codLocal: string
  usuario: string
  contrasenia: string
}

interface Props {
  open: boolean
  setOpen: (open: boolean) => void
  data: ResData
  setData: (data: ResData) => void
  newTenant: ITenant
  setNewTenant: (tenant: ITenant) => void
}

const DialogResponse: React.FC<Props> = ({ open, setOpen, data, setData, newTenant, setNewTenant }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [userCopied, setUserCopied] = useState<boolean>(false)
  const [passCopied, setPassCopied] = useState<boolean>(false)

  const handleCopy = (text: string, label: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        SnackBarUtils.info(`${label} al portapapeles`)
        if (label.includes('Usuario')) {
          setUserCopied(true)
          setPassCopied(false)
        } else {
          setPassCopied(true)
          setUserCopied(false)
        }
      })
      .catch(() => {
        SnackBarUtils.error('Error al copiar')
      })
  }

  const handleClose = () => {
    setOpen(false)
    setData(null)
    setNewTenant(null)
  }

  if (!data || !newTenant) return

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={isMobile ? 'xs' : 'sm'}
        PaperProps={{
          style: {
            overflowX: 'hidden',
            ...(isMobile && { marginLeft: '-1rem' })
          }
        }}
      >
        <DialogTitle style={{ marginTop: '0.5rem' }}>Datos de acceso a la app {newTenant.nombre}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Typography>Su USUARIO es: {data.usuario}</Typography>
            <IconButton
              size="small"
              onClick={() => handleCopy(data.usuario, 'Usuario copiado')}
              sx={{ padding: '4px' }}
            >
              <ContentCopyIcon color={userCopied ? 'primary' : 'inherit'} fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Typography>Su NUEVA CONTRASEÑA es: {data.contrasenia}</Typography>
            <IconButton
              size="small"
              onClick={() => handleCopy(data.contrasenia, 'Contraseña copiada')}
              sx={{ padding: '4px' }}
            >
              <ContentCopyIcon color={passCopied ? 'primary' : 'inherit'} fontSize="small" />
            </IconButton>
          </Box>
          <Typography>⚠️ Recuerde que desde modificar perfil puede modificarla para mayor seguridad.</Typography>
        </DialogContent>
        <IconButton
          disabled={loading}
          edge="end"
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '16px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </Dialog>
    </>
  )
}

export default DialogResponse
